import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["toggle"]
  static values = {
    url: String,
    conversionActionId: Number,
    field: { type: String, default: "is_switch_owned" }
  }

  async toggle() {
    const toggleEl = this.toggleTarget
    const isCurrentlyOn = toggleEl.getAttribute("aria-checked") === "true"
    const newValue = !isCurrentlyOn

    // Optimistic UI update
    this.updateToggleUI(toggleEl, newValue)

    try {
      const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
      const body = new URLSearchParams({
        conversion_action_id: this.conversionActionIdValue
      })
      body.set(this.fieldValue, newValue.toString())

      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-CSRF-Token": csrfToken,
          "Accept": "text/vnd.turbo-stream.html"
        },
        body
      })

      if (!response.ok) {
        // Revert on failure
        this.updateToggleUI(toggleEl, isCurrentlyOn)
        return
      }

      // A bare fetch() doesn't route through Turbo, so apply the stream ourselves — this is
      // what re-renders the row (or the whole funnel panel, moving the CA between groups).
      Turbo.renderStreamMessage(await response.text())
    } catch {
      // Revert on error
      this.updateToggleUI(toggleEl, isCurrentlyOn)
    }
  }

  updateToggleUI(el, isOn) {
    el.setAttribute("aria-checked", isOn.toString())

    // Detect the on-color from the element's current classes
    let onClass = "bg-sg-green"
    if ((el.classList.contains("bg-purple-500") || el.classList.contains("bg-sg-gray-200")) && this.fieldValue === "is_modeling") {
      onClass = "bg-purple-500"
    } else if (el.classList.contains("bg-indigo-600") || el.classList.contains("bg-gray-200")) {
      onClass = "bg-indigo-600"
    }
    const offClass = onClass === "bg-indigo-600" ? "bg-gray-200" : "bg-sg-gray-200"
    el.classList.toggle(onClass, isOn)
    el.classList.toggle(offClass, !isOn)

    const dot = el.querySelector("span")
    if (dot) {
      dot.classList.toggle("translate-x-4", isOn)
      dot.classList.toggle("translate-x-0", !isOn)
    }
  }
}
